const PUBLIC_EMAILS = [
    '@gmail.com',
    '@yahoo.com',
    '@hotmail.com',
    '@outlook.com',
    '@live.com',
    '@icloud.com',
    '@aol.com',
    '@ymail.com',
    '@protonmail.com',
    '@proton.me',
    '@mail.com',
    '@zoho.com',
    '@gmx.com',
    '@inbox.com',
    '@msn.com',
    '@me.com',
    '@mac.com',
    '@yandex.com',
    '@yandex.ru',
    '@ya.ru',
    '@mail.ru',
    '@bk.ru',
    '@list.ru',
    '@inbox.ru',
    '@internet.ru',
    '@rambler.ru',
    '@fastmail.com',
    '@tutanota.com',
    '@mailfence.com',
    '@mailbox.org',
];
export const isPublicEmail = (data: string) => {
    const email = data.toLowerCase();
    return PUBLIC_EMAILS.some((item) => email.includes(item));
}
const validateEmail = (email: string) => {
    const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return Boolean(String(email).toLowerCase().match(EMAIL_REGEX));
};

export default validateEmail;